export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s was not chosen';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s cannot be empty';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s is a mandatory field';
                break;

            case 'address-autocomplete':
                translation = 'Please select an address from the list';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s was not filled out correctly';
                break;

            case 'opt-in':
                translation = 'Please check the box to continue';
                break;

            default:
                translation = 'This field was not filled out correctly';
                break;
        }

        return translation;
    }

    /**
     * @link https://developers.google.com/maps/documentation/geocoding/intro?hl=nl#StatusCodes
     */
    addressMap(textType) {
        let translation = '';

        switch (textType) {
            case 'ZERO_RESULTS':
                translation = 'No results found';
                break;

            case 'address-not-checked':
                translation = 'Drag the map and drop the pin on the roof of your house';
                break;

            default:
                translation = 'An error has occured';
                break;
        }

        return translation;
    }
}
